export default "__VITE_ASSET__DiNOPF9z__"